// Same cheap "does From match a known contact (or this record's own email
// domain)" heuristic every touchpoints/timeline feed in the app uses to pick
// the received/sent arrow — shared here so the site dashboard, owner rollup
// and company detail read it the same way instead of drifting.
//
// ponytail: no real domain-matching (SPF/DKIM-aware) — a lookalike domain or
// a contact with no email on file both fall through to 'sent'. Upgrade path:
// resolve direction server-side from the synced mailbox's own address once
// that's threaded through the API.
import type { Activity, Company, Person } from '$lib/types';

function domainOf(addr: string): string {
  return addr.split('@')[1]?.toLowerCase().trim() ?? '';
}

export function emailDirection(
  a: Activity,
  people: Person[],
  company?: Pick<Company, 'email'> | null
): 'received' | 'sent' {
  const from = a.email?.from_addr?.toLowerCase() ?? '';
  const person = a.person_id ? people.find((p) => p.id === a.person_id) : undefined;
  if (person?.email && person.email.toLowerCase() === from) return 'received';
  if (company?.email && domainOf(company.email) === domainOf(from)) return 'received';
  return 'sent';
}
